import { formatArray } from "lib/arrayObject";
import http from "lib/http";
import { isObject } from "lodash";
import store from "store";

export const updateStore = (state = {}, payload) => {
  return !payload
    ? state
    : typeof payload === "function"
    ? payload(state)
    : isObject(payload)
    ? {
        ...state,
        ...payload,
      }
    : state;
};

export const formatAuthStore = (data = {}) => {
  const token = data?.token ?? "";
  // const isAuth = moment(data?.expire_at, YMDHMS, true).isAfter(moment());
  const isAuth = Boolean(token);

  if (isAuth) {
    http.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  return {
    ...data,
    isAuth: isAuth,
  };
};

export const openLoading = (isOpen = false) => {
  store.dispatch({
    type: "SET_COMMON",
    payload: (s = {}) => ({
      ...(s ?? {}),
      isLoading: Boolean(isOpen),
    }),
  });
};

export const defaultCommonModalData = {
  isOpen: false,
  isOk: false,
  title: "",
  content: "",
  onClose: () => {},
  onOk: () => {},
};

export const openModal = ({
  size = "sm",
  title = "",
  content = "",
  footer = "",
  noFrame = false,
  onClose = () => {},
  onSave,
}) => {
  store.dispatch({
    type: "SET_COMMON",
    payload: (s = {}) => ({
      ...(s ?? {}),
      modal: [
        ...formatArray(s?.modal),
        {
          isOpen: true,
          noFrame: noFrame,
          size: size,
          title: title,
          content: content,
          footer: footer,
          onClose: onClose,
          onSave: onSave,
        },
      ],
    }),
  });
};

export const closeModal = () => {
  store.dispatch({
    type: "SET_COMMON",
    payload: (s = {}) => ({
      ...(s ?? {}),
      modal: formatArray(s?.modal).slice(0, -1),
    }),
  });
};
